import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, TRANSLATION_KEY, {
  MODULE_HOME: 'Inicio',
  MODULE_HANA: 'Hana AI',
  MODULE_RECOGNITION: 'Reconocimiento',
  MODULE_PERFORMANCE: 'Desempeño',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Compañía',
  MODULE_ANALYTICS: 'Analítica',
  MODULE_ADMIN: 'Administrar',
  MODULE_STATISTICS: 'Estadísticas',
  MODULE_REPORTS: 'Reportes',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitorea tus procesos y genera reportes.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: 'Analiza la data de tu compañía con Inteligencia Artificial.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTOS',
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Gestiona las medallas otorgadas por los colaboradores.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Evalúa el rendimiento, a través de objetivos y competencias.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Mide la cultura y satisfacción de tu equipo.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: 'Gestiona estrategias de aprendizaje y potencia las habilidades de tus equipos.',
  MODULE_COMPANY_USERS: 'Usuarios',
  MODULE_COMPANY_EXTRA_FIELDS: 'Atributos personalizados',
  MODULE_COMPANY_DEPARTMENTS: 'Departamentos',
  MODULE_COMPANY_JOBS: 'Cargos',
  MODULE_COMPANY_ORGCHART: 'Organigrama',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Gestiona tus usuarios y la configuración de la compañía.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Crea usuarios y gestiona la estructura organizacional',
  MODULE_ACCOUNT: 'Cuenta',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Gestiona los datos de la cuenta y consulta el consumo de licencias',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'Historial de acciones realizadas en la cuenta.',
  MODULE_APPEREANCE: 'Apariencia',
  MODULE_APPEREANCE_TOOLTIP_DESCRIPTION: 'Personaliza el panel con la identidad organizacional',
  MODULE_COMMUNICATION: 'Comunicación',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Personaliza las notificaciones para tus usuarios',
  MODULE_AUTOMATIZATIONS: 'Automatizaciones',
  MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION: 'Crea reglas de automatización para agilizar tareas',
  // learning links
  LEARNING_LINK_CONTENT: 'Contenido',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Gestiona los cursos, rutas de aprendizaje y otros recursos',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_PATHS: 'Rutas de aprendizaje',
  LEARNING_LINK_PROJECTS: 'Proyectos',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill-XP evolution',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Mide las habilidades de cada persona',
  LEARNING_LINK_GAMIFICATION: 'Gamificación',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Crear, gestionar y premia logros de aprendizaje',
  LEARNING_LINK_PROGRESS: 'Progreso',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitorea tus procesos y genera reportes',
  LEARNING_LINK_SHOP: 'Tienda',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Personaliza tu tienda virtual de contenido',
  LEARNING_LINK_INTEGRATIONS: 'Integraciones',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Conecta la plataforma con otros sistemas',
  // submodules
  SUBMODULE_RESULTS: 'Resultados',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas',
  SUBMODULE_MY_TEAM: 'Mi equipo',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitorea los resultados de tu equipo',
  SUBMODULE_ADMIN_RESULTS: 'Resultados',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitorea el ranking de medallas obtenidas por tus colaboradores.',
  SUBMODULE_MEDALS_REQUETS: 'Solicitud de medallas',
  SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION: 'Aprueba o rechaza las medallas que se envían los colaboradores.',
  SUBMODULE_REWARDS: 'Recompensas',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Gestiona y entrega las recompensas canjeadas.',
  SUBMODULE_CONFIGURATION: 'Configuración',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Crea medallas, define reglas y mensajes.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Resultados',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Mide el desempeño y el compromiso de los equipos.',
  SUBMODULE_COMPETENCES: 'Competencias',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Crea y asigna evaluaciones de competencias.',
  SUBMODULE_GOALS: 'Metas',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Planea y establece tus compromisos de trabajo',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualiza el progreso de la estrategia empresarial y reconoce el esfuerzo para cumplir los objetivos',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Mide los procesos de feedback de tu compañía.',
  SUBMODULE_PID: 'Plan individual de desarrollo',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Crea procesos para cerrar brechas y promover el crecimiento.',
  SUBMODULE_SUCCESSION_PLAN: 'Plan de sucesión',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Crea planes de acción para futuras vacantes.',
  SUBMODULE_LINK_GOALS: 'Objetivos',
  SUBMODULE_LINK_ALIGNMENT: 'Alineación',
  SUBMODULE_LINK_CONFIGURATION: 'Configuracion',
  SUBMODULE_CLIMATE_EVALUATION: 'Evaluaciones de Clima',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Accede al cuestionario para mediar el clima organizacional',
  SUBMODULE_SHORT_SURVEY: 'Encuestas cortas',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Recolecta información de manera rápida y sencilla.',
  SUBMODULE_OTHER_EVALUATIONS: 'Otras evaluaciones',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Evaluaciones adicionales como riesgos psicosociales.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medallas',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Mensajes',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Reglas y permisos',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Crea matrices cruzando variables para visualizar datos.'
});